import GoogleProductCategoriesAPI from './googleProductCategories';

const TTL = 24 * 60 * 60 * 1000; // 24h
let cached = null;
let cachedAt = null;
let inflight = null;

export async function loadGoogleTaxonomy(accountId) {
  const now = Date.now();
  if (cached && cachedAt && now - cachedAt < TTL) return cached;
  if (inflight) return inflight;

  inflight = GoogleProductCategoriesAPI.get(accountId)
    .then(res => {
      cached = res.data?.data || [];
      cachedAt = Date.now();
      inflight = null;
      return cached;
    })
    .catch(err => {
      inflight = null;
      throw err;
    });

  return inflight;
}

export function clearGoogleTaxonomyCache() {
  cached = null;
  cachedAt = null;
  inflight = null;
}
